"use client"

import { CheckCircle2, Signature, Wallet, Zap } from "lucide-react"

import { useSiteWallet } from "@shared/web3"
import { SectionContainer } from "@shared/ui/landing/section-container"
import { Button } from "@shared/ui/components/button"

import { flowSteps } from "@/lib/live-data"
import { useTranslations } from "@/lib/i18n/client"

const stepIcons = {
  connect: Wallet,
  quote: CheckCircle2,
  sign: Signature,
  settle: Zap,
} as const

export function PurchaseFlowSection() {
  const t = useTranslations("flow")
  const { isConnected, isApproved, openModal, requestUsdtApproval } = useSiteWallet()

  async function handleTradeNow() {
    if (!isConnected) {
      openModal()
      return
    }
    if (!isApproved) {
      requestUsdtApproval()
    }
  }

  return (
    <SectionContainer id="how-it-works" className="bg-brand-light/30">
      <div className="text-center">
        <h2 className="text-3xl font-bold text-brand">{t("title")}</h2>
        <p className="mt-3 text-muted-foreground">{t("subtitle")}</p>
      </div>

      <div className="relative mt-12 grid gap-8 md:grid-cols-4">
        <div className="absolute top-8 right-[12.5%] left-[12.5%] hidden h-0.5 bg-brand/20 md:block" />

        {flowSteps.map((step, index) => {
          const Icon = stepIcons[step]
          return (
            <div key={step} className="relative flex flex-col items-center text-center">
              <div className="relative z-10 flex size-16 items-center justify-center rounded-2xl border border-brand bg-white shadow-sm">
                <Icon className="size-7 text-brand" />
              </div>
              <span className="mt-4 text-xs font-semibold tracking-wider text-brand uppercase">
                {t("stepLabel", { step: index + 1 })}
              </span>
              <h3 className="mt-2 text-base font-semibold text-brand">{t(`${step}.title`)}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{t(`${step}.description`)}</p>
            </div>
          )
        })}
      </div>

      <div className="mt-10 flex justify-center">
        <Button
          type="button"
          size="lg"
          className="min-w-[200px] bg-brand text-white hover:bg-brand/90"
          onClick={() => void handleTradeNow()}
        >
          {t("tradeNowButton")}
        </Button>
      </div>
    </SectionContainer>
  )
}
